/*
  sf-tira
  Los dos modos de la tira de imagenes (sf-logos).

  MODO BUCLE. El CSS por si solo no puede hacerlo bien y por eso lo maneja este archivo.
  Para que el bucle no deje un hueco, la mitad de la pista que se desplaza tiene que ser
  al menos tan ancha como la ventana. Cuantas copias hacen falta depende del ancho REAL
  de las imagenes, que a su vez depende del alto configurado, de la separacion y del
  tamano de la pantalla. Nada de eso se sabe en Liquid.
  El primer intento contaba imagenes (6 o mas -> 2 copias) y estaba mal: nueve logos
  chicos daban 1040 px contra una ventana de 1799 y el bucle se quedaba sin contenido.
  Aca se mide y se clona hasta llegar, y la animacion se hace con la Web Animations API
  para poder desplazar una cantidad EXACTA de pixeles en vez de un porcentaje.
  Si el JS no corre, queda la animacion CSS que dibuja Liquid: peor, pero no rota.

  MODO DESLIZAR. Una sola copia, nada se repite, se arrastra con el dedo o el mouse.
  Pedido del cliente del 2026-09-08: "que se pasen solas o que se pueda deslizar
  manualmente para mirar las fotos".

  El deslizar con el dedo y con la rueda lo hace el navegador solo, porque el marco es un
  contenedor con scroll de verdad. Aca esta lo unico que el navegador no da gratis:
  arrastrar con el mouse en PC, y el pasar solo.

  Al llegar al final vuelve al principio. Ese salto se ve, y esta bien que se vea: en este
  modo NO se duplica nada, que es justamente lo que se pidio.
*/
(function () {
  'use strict';

  var arrancadas = new WeakSet();
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Deja la pista con DOS mitades identicas, cada una al menos tan ancha como la
     ventana, y la anima justo el ancho de una mitad. Asi lo que aparece por la derecha
     es siempre igual a lo que salio por la izquierda y no se ve ningun corte. */
  function armarBucle(marco, pista) {
    var grupos = [].slice.call(pista.children);
    if (!grupos.length) return null;

    var base = grupos[0];
    var anchoGrupo = base.getBoundingClientRect().width;
    if (!anchoGrupo) return null;
    var ventana = marco.clientWidth;
    var porMitad = Math.max(1, Math.ceil(ventana / anchoGrupo));

    // se rehace la pista: la primera copia es la original (lleva los atributos del
    // editor de temas), el resto son clones limpios para no repetir ids de bloque
    var limpio = base.cloneNode(true);
    limpio.setAttribute('aria-hidden', 'true');
    [].slice.call(limpio.querySelectorAll('[data-shopify-editor-block]')).forEach(function (e) {
      e.removeAttribute('data-shopify-editor-block');
    });
    [].slice.call(limpio.querySelectorAll('a')).forEach(function (a) {
      a.setAttribute('tabindex', '-1');
    });

    pista.innerHTML = '';
    pista.appendChild(base);
    for (var i = 1; i < porMitad * 2; i++) pista.appendChild(limpio.cloneNode(true));

    return { mitad: anchoGrupo * porMitad, gruposPorMitad: porMitad };
  }

  function iniciar(marco) {
    if (!marco || arrancadas.has(marco)) return;
    var pista = marco.querySelector('.sf-logos__pista');
    if (!pista) return;
    arrancadas.add(marco);

    if (marco.getAttribute('data-modo') !== 'deslizar') return iniciarBucle(marco, pista);

    var segundos = Number(marco.getAttribute('data-auto')) || 0;
    var reloj = null;
    var arrastrando = false;
    var desdeX = 0;
    var desdeScroll = 0;
    var movido = 0;

    /* Posicion de cada imagen dentro de la pista, medida de verdad. Sumar un ancho fijo
       solo funciona si todas miden lo mismo, y con "Ancho fijo" en 0 cada foto conserva
       su proporcion. */
    function bordes() {
      var base = marco.getBoundingClientRect().left + marco.scrollLeft;
      return [].slice.call(marco.querySelectorAll('.sf-logos__item')).map(function (it) {
        return Math.round(it.getBoundingClientRect().left - base);
      });
    }

    function avanzar() {
      var max = pista.scrollWidth - marco.clientWidth;
      var aqui = marco.scrollLeft;
      var destino;
      if (aqui >= max - 2) {
        destino = 0;
      } else {
        var xs = bordes();
        var siguiente = null;
        for (var i = 0; i < xs.length; i++) {
          if (xs[i] > aqui + 2) { siguiente = xs[i]; break; }
        }
        destino = siguiente === null ? max : Math.min(siguiente, max);
      }
      marco.scrollTo({ left: destino, behavior: quieto.matches ? 'auto' : 'smooth' });
    }

    function arrancar() {
      parar();
      if (!segundos || quieto.matches) return;
      reloj = window.setInterval(function () {
        if (document.hidden || arrastrando) return;
        avanzar();
      }, segundos * 1000);
    }
    function parar() {
      if (reloj) { window.clearInterval(reloj); reloj = null; }
    }

    marco.addEventListener('mouseenter', parar);
    marco.addEventListener('mouseleave', arrancar);
    marco.addEventListener('focusin', parar);
    marco.addEventListener('focusout', arrancar);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    // Arrastrar con el mouse. En pantalla tactil no hace falta y ademas estorbaria,
    // asi que solo se engancha donde hay cursor de verdad.
    if (window.matchMedia('(hover: hover)').matches) {
      // El navegador arrastra imagenes y enlaces por su cuenta. Si lo hace, se lleva el
      // puntero y el pointerup no vuelve nunca: la tira se queda con el enganche apagado
      // y el cursor trabado. Se corta de raiz.
      marco.addEventListener('dragstart', function (e) { e.preventDefault(); });

      function soltar() {
        if (!arrastrando) return;
        arrastrando = false;
        marco.style.cursor = '';
        marco.style.scrollSnapType = '';
        arrancar();
      }

      marco.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        arrastrando = true;
        movido = 0;
        desdeX = e.clientX;
        desdeScroll = marco.scrollLeft;
        marco.style.cursor = 'grabbing';
        marco.style.scrollSnapType = 'none';
        // capturar el puntero garantiza que el pointerup llegue aunque se suelte
        // fuera de la tira o encima de otra cosa
        if (marco.setPointerCapture) {
          try { marco.setPointerCapture(e.pointerId); } catch (err) {}
        }
        e.preventDefault();
      });
      marco.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var d = e.clientX - desdeX;
        movido = Math.max(movido, Math.abs(d));
        marco.scrollLeft = desdeScroll - d;
      });
      marco.addEventListener('pointerup', soltar);
      marco.addEventListener('pointercancel', soltar);
      // ultimo cinturon: si por lo que sea el puntero se pierde, no queda pegado
      window.addEventListener('blur', soltar);
      // Si arrastro de verdad, el clic que viene despues NO tiene que abrir el enlace.
      marco.addEventListener('click', function (e) {
        if (movido > 6) {
          e.preventDefault();
          e.stopPropagation();
          movido = 0;
        }
      }, true);
      marco.style.cursor = 'grab';
    }

    arrancar();
  }

  function iniciarBucle(marco, pista) {
    var animacion = null;
    var anchoPrevio = 0;

    function montar() {
      // armarBucle siempre mide UN grupo y rehace la pista desde ese, asi que se puede
      // llamar las veces que haga falta sin que las copias se multipliquen
      if (animacion) { animacion.cancel(); animacion = null; }
      var datos = armarBucle(marco, pista);
      if (!datos) return;

      pista.style.animation = 'none';   // se apaga la del CSS, que va por porcentaje
      if (quieto.matches) return;

      var porImagen = Number(marco.getAttribute('data-seg-img')) || 3;
      var porGrupo = pista.firstElementChild ? pista.firstElementChild.children.length : 1;
      var segundos = Math.max(4, porImagen * porGrupo * datos.gruposPorMitad);
      var alReves = marco.getAttribute('data-sentido') === 'derecha';

      animacion = pista.animate(
        [
          { transform: 'translateX(' + (alReves ? -datos.mitad : 0) + 'px)' },
          { transform: 'translateX(' + (alReves ? 0 : -datos.mitad) + 'px)' }
        ],
        { duration: segundos * 1000, iterations: Infinity, easing: 'linear' }
      );
    }

    montar();
    anchoPrevio = marco.clientWidth;
    if (document.readyState !== 'complete') {
      window.addEventListener('load', montar, { once: true });
    }

    if (marco.getAttribute('data-pausar') === '1') {
      marco.addEventListener('mouseenter', function () { if (animacion) animacion.pause(); });
      marco.addEventListener('mouseleave', function () { if (animacion) animacion.play(); });
      marco.addEventListener('focusin', function () { if (animacion) animacion.pause(); });
      marco.addEventListener('focusout', function () { if (animacion) animacion.play(); });
    }

    var espera = null;
    window.addEventListener('resize', function () {
      if (marco.clientWidth === anchoPrevio) return;
      anchoPrevio = marco.clientWidth;
      window.clearTimeout(espera);
      espera = window.setTimeout(montar, 200);
    });
  }

  function todas(raiz) {
    var d = raiz || document;
    [].slice.call(d.querySelectorAll('[data-sf-tira]')).forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { todas(); });
  } else {
    todas();
  }
  document.addEventListener('shopify:section:load', function (e) { todas(e.target); });
})();
